const pad = (value: number) => value.toString().padStart(2, '0');

export default function formatDate(date: Date | string, format = 'd-m-Y') {
  let dateToFormat = date;

  if (typeof date === 'string') {
    dateToFormat = new Date(date);
  }

  const day = pad((dateToFormat as Date).getDate());
  const month = pad((dateToFormat as Date).getMonth() + 1);
  const year = (dateToFormat as Date).getFullYear();
  const hours = pad((dateToFormat as Date).getHours());
  const minutes = pad((dateToFormat as Date).getMinutes());

  return format
    .replace('d', day.toString())
    .replace('m', month.toString())
    .replace('Y', year.toString())
    .replace('H', hours)
    .replace('i', minutes);
}
